import { forwardRef, Inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { SubscriptionSetPaymentStatus } from '../../model/index';


@Pipe({ name: 'paymentStatus' })
export class PaymentStatusPipe implements PipeTransform {

    constructor(@Inject(forwardRef(() => DomSanitizer)) private sanitizer: DomSanitizer) { }

    transform(value: SubscriptionSetPaymentStatus, bypassSanitize?: boolean): any {
        if (!value) {
            return '';
        }
        const style = this.getStyle(value);
        const result = `<div class="sm-status-badge" style="${style}">
                            ${value}
                        </div>`;
        if (bypassSanitize) {
            return this.sanitizer.bypassSecurityTrustHtml(result);
        }
        return result;
    }

    private getStyle(value: SubscriptionSetPaymentStatus): string {
        if (value == SubscriptionSetPaymentStatus.PENDING) {
            return "color: #DF2316; background-color: #FFEBED;";
        } else { // PAID
            return "color: #212121; background-color: #2121211F;";
        }
    }
}